/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

    /**
     * Creates an product card offers box instance
     *
     * @module enervee_utils.product_card
     */
function productCardOffersButtonDirective() {
    return {
        restrict: 'E',
        scope: {
            product: '=',
        },
        link: link,
        controller: productCardOffersButtonController,
        template: require('./offersButtonView.html')
    };
}

productCardOffersButtonController.$inject = [
    '$scope',
    'AnalyticsService',
    'CmsContentService',
    'ProductService',
    'UtilService'
];
function productCardOffersButtonController(
    $scope,
    AnalyticsService,
    CmsContentService,
    ProductService,
    UtilService
) {
    $scope.quantity = 3;

    var offersHaveBeenViewed = false;

     // Filters best_online_offers for active and inactive offers
    var currentOffers = [];
    if ('offers_json' in $scope.product) {
        currentOffers = $scope.product.offers_json.filter(function (offer) {
            return offer.is_active;
        });
    } else if ('best_online_offers' in $scope.product) {
        currentOffers = $scope.product.best_online_offers.filter(function (offer) {
            return offer.is_active;
        });
    }

    if (currentOffers.length > 0) {
        // If there is at least one active offer, display only active offers
        $scope.product.best_online_offers = currentOffers;
        $scope.product.active_offers = true;

    } else {
        // Else, use the inactive offer list
        $scope.product.best_online_offers = [];
        $scope.product.active_offers = false;
    }

    var bestOnlineOffersCount = $scope.product.best_online_offers.length;

    if (bestOnlineOffersCount === 1) {
        CmsContentService.getMarketPlaceText(
            'product_card:offers_count_singular',
            {
                'store_name': $scope.product.best_online_offers[0].store_name
            },
            $scope.product.category.id
        ).then(function (text) {
            $scope.product.seeBestOffers = text;
        });
    } else if (bestOnlineOffersCount === 0) {
        $scope.product.seeBestOffers = '0 offers available';
    } else {
        CmsContentService.getMarketPlaceText(
            'product_card:offers_count_pluralized',
            {
                'offers_count': bestOnlineOffersCount
            },
            $scope.product.category.id
        ).then(function (text) {
            $scope.product.seeBestOffers = text;
        });
    }

    $scope.showOffersBox = function () {
        // If there are offers, allow the offers box to be visible
        if ($scope.product.best_online_offers.length !== 0) {
            $scope.product.offersBoxIsVisible = true;
            UtilService.focusElement($scope.elem.find('.card-hide-offers-btn'));

            // Checks the "offersHaveBeenViewed" boolean, then sets it to true if it isn't
            // already, in order to only execute the logic in the "if" block once.
            if (!offersHaveBeenViewed) {
                offersHaveBeenViewed = true;
                // Just consider the offers shown
                var offers = $scope.product.best_online_offers;
                offers = offers.slice(0, $scope.quantity);
                offers.forEach(function (offer, index) {
                    var offerDetails = ProductService.getOfferTrackingDetails(offer);
                    offerDetails.position = index + 1;
                    AnalyticsService.reportEvent('Offer Viewed', offerDetails, $scope.product);
                });
            }
        }
    };
}

function link(scope, elem) {
    scope.elem = elem;
}

module.exports = productCardOffersButtonDirective;
